"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    var _a, _b;
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    if (typeof ((_a = window.adobeDataLayer) === null || _a === void 0 ? void 0 : _a.getState) === 'undefined')
        return;
    if (typeof ((_b = window.adobeDataLayer) === null || _b === void 0 ? void 0 : _b.push) === 'undefined')
        return;
    const pageKey = window.adobeDataLayer.getState('page');
    const pageObjectTopKey = Object.keys(pageKey || {})[0];
    const updatedPageObject = {};
    updatedPageObject[pageObjectTopKey] = {
        'dc:title': `${e.page}`,
        'pageName': `${e.page}`,
        'pageType': 'Aiba Application',
    };
    window.adobeDataLayer.push({
        event: 'ajaxPageLoad',
        page: updatedPageObject,
    });
};
exports.launchEvent = launchEvent;
